import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';
import { Response } from '@features/state';
import { useAppContext } from '@common/contexts/AppContext';
import { TablesSettingsSchema } from '../schemas/TablesSettings.schema';

export function useTablesSettings() {
  const { siteSlug } = useAppContext();

  return useQuery({
    queryKey: getTablesSettingsKey({ siteSlug }),
    queryFn: () => getTablesSettings({ siteSlug }),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}

export async function getTablesSettings({ siteSlug }: { siteSlug: string }) {
  const response = await request.v2.get(`/store/pages/site/${siteSlug}/settings/tables`);
  return Response(TablesSettingsSchema).parse(response.data);
}

export const getTablesSettingsKey = ({ siteSlug }: { siteSlug: string }) => [
  'tablesSettings',
  siteSlug,
];
